export const ADMIN = 'admin'
export const SUPER_ADMIN = 'superAdmin'
export const FARMER = 'farmer'
export const CONSULTANT = 'consultant'
